<template>
  <v-dialog
    :value="value"
    max-width="420"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          text
          :disabled="loading"
          @click="cancel"
        >
          Отмена
        </v-btn>

        <v-btn
          color="error"
          :loading="loading"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          Удалить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteConfirmDialog",

  props: {
    value: {
      type: Boolean,
      required: true,
    },

    title: {
      type: String,
      default: "Подтверждение удаления",
    },

    message: {
      type: String,
      default: "Вы действительно хотите удалить запись?",
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    cancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
  },
};
</script>